// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2fETS","col":"Table_col__2TeYs","fulfillmentStatus":"Table_fulfillmentStatus__IHYWy","emailCol":"Table_emailCol__-r0KX"};